import type { CommerceAddress, CommerceCheckoutContact } from "@teqtank/commerce-contracts";
import { CommerceError } from "../errors/commerce-error.js";

export function normalizeCheckoutContact(value: CommerceCheckoutContact): CommerceCheckoutContact {
    const email = value.email.trim().toLowerCase();
    if (!/^\S+@\S+\.\S+$/.test(email))
        throw new CommerceError(
            "checkout-address-invalid",
            "A valid Checkout email address is required.",
            { field: "email" },
        );
    return { email, phone: value.phone.trim(), acceptsMarketing: value.acceptsMarketing };
}

export function normalizeCheckoutAddress(value: CommerceAddress): CommerceAddress {
    const required = [
        value.firstName,
        value.lastName,
        value.addressLine1,
        value.city,
        value.postalCode,
        value.countryCode,
    ];
    if (required.some((item) => item.trim().length === 0))
        throw new CommerceError("checkout-address-invalid", "The Checkout address is incomplete.");
    return {
        firstName: value.firstName.trim(),
        lastName: value.lastName.trim(),
        ...(value.company?.trim() ? { company: value.company.trim() } : {}),
        addressLine1: value.addressLine1.trim(),
        ...(value.addressLine2?.trim() ? { addressLine2: value.addressLine2.trim() } : {}),
        city: value.city.trim(),
        region: value.region.trim(),
        postalCode: value.postalCode.trim(),
        countryCode: value.countryCode.trim().toUpperCase(),
        ...(value.phone?.trim() ? { phone: value.phone.trim() } : {}),
    };
}

export function requireCheckoutIdentifier(value: string, label: string): string {
    const normalized = value.trim();
    if (normalized.length === 0)
        throw new CommerceError("checkout-shipping-invalid", `${label} is required.`);
    return normalized;
}
